var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('img',{staticClass:"noselect",attrs:{"src":require("@/assets/loading2.gif"),"alt":"Carregando"}}),_c('p',{attrs:{"id":"caption_1"}},[_vm._v(_vm._s(this.caption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }